import React, { FC } from 'react';
import styled from 'styled-components';

import { StyledConfirmOrCancelModal } from 'src/presentation/components/pages/shared/rowActions/StyledConfirmOrCancelModal';

type ActiveMessageAutomationModalProps = {
  onCancel: Function;
  onSubmit: Function;
  title: string;
};

const ActivateMessageAutomationModal: FC<ActiveMessageAutomationModalProps> = ({ onSubmit, onCancel, title }) => {
  return (
    <StyledConfirmOrCancelModal
      data-aid={'activate-message-automation-modal'}
      submitText={'Yes, proceed'}
      cancelText={'Cancel'}
      children={<ModalContent />}
      confirmOnDismiss={false}
      onCancel={onCancel}
      onSubmit={onSubmit}
      title={title}
    />
  );
};

const ModalContent: FC = () => {
  return (
    <StyledModalContent>
      <p>
        Messages will first be routed to your automation partner instead of an agent. If your automation is not set up,
        and you check this box, you will miss incoming messages.
      </p>
      <p>Are you sure you want to proceed?</p>
    </StyledModalContent>
  );
};

const StyledModalContent = styled.div`
  width: 506px;

  p {
    text-align: center;
    vertical-align: middle;
  }
`;

export default ActivateMessageAutomationModal;
